import { connect } from 'react-redux';
import UploadAbsensiHarian from '../../../views/Student/absensi/UploadAbsensiHarian.student.view';

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

export default connect(mapStateToProps)(UploadAbsensiHarian);
